import { defineAsyncComponent } from 'vue'

// 统一的异步组件函数 - 带加载提示的异步组件
const createAsyncComponent = (path) => {
  return defineAsyncComponent({
    loader: () => import(path),
    loadingComponent: () => import('../../components/LoadingComponent.vue'),
    errorComponent: () => import('../../components/ErrorComponent.vue'),
    delay: 200,
    // timeout: 3000
  })
}

export default [
  // {
  //   path: '/activity/chart',
  //   name: 'ChartActivity',
  //   component: asyncComponent('../../views/chartActivity/index.vue'),
  //   meta: {
  //     title: '活动图表',
  //     keepAlive: true // 是否缓存页面
  //   }
  // },
  {
    path: '/activity/chart-page',
    name: 'ChartActivityPage',
    component: createAsyncComponent('../../pages/chartActivityPage/index.vue'),
    meta: {
      title: '榜单活动',
      keepAlive: false // 是否缓存页面
    }
  },
  {
    path: '/activity/reward',
    name: 'RewardPage',
    component: createAsyncComponent('../../pages/rewardPage/index.vue'),
    meta: {
      title: '榜单活动(上月)',
      keepAlive: false
    }
  },
  {
    path: '/prettyNumberBanner/index',
    name: 'prettyNumberBanner',
    component: createAsyncComponent('../../pages/prettyNumberBanner/index.vue'),
    meta: {
      title: '靓号banner页',
      keepAlive: true
    }
  },
  {
    path: '/guildEventsPage/index',
    name: 'guildEventsPage',
    component: createAsyncComponent('../../pages/guildEventsPage/index.vue'),
    meta: {
      title: '公会活动',
      keepAlive: false
    }
  },
  {
    path: '/lastGuildEventsPage/index',
    name: 'lastGuildEventsPage',
    component: createAsyncComponent('../../pages/lastGuildEventsPage/index.vue'),
    meta: {
      title: '公会活动',
      keepAlive: false
    }
  },
  {
    path: '/userLevelActivityPage/index',
    name: 'userLevelActivityPage',
    component: createAsyncComponent('../../pages/userLevelActivityPage/index.vue'),
    meta: {
      title: '用户等级活动',
      keepAlive: false
    }
  },
  {
    path: '/guideRules/index',
    name: 'guideRules',
    component: createAsyncComponent('../../pages/guideRules/index.vue'),
    meta: {
      title: '指南规则页',
      keepAlive: false
    }
  },
  {
    path: '/guideRulesAr/index',
    name: 'guideRulesAr',
    component: createAsyncComponent('../../pages/guideRulesAr/index.vue'),
    meta: {
      title: '指南规则页(阿语版)',
      keepAlive: false
    }
  },
  {
    path: '/bindRulesAr/index',
    name: 'bindRulesAr',
    component: createAsyncComponent('../../pages/bindRulesAr/index.vue'),
    meta: {
      title: '绑定规则页(阿语版)',
      keepAlive: false
    }
  },
  {
    path: '/yyh5',
    name: 'imageProxy',
    component: createAsyncComponent('../../pages/imageProxy/index.vue'),
    meta: {
      title: '图片动态化',
      keepAlive: false
    }
  },
  {
    path: '/userRoomRank',
    name: 'userRoomRank',
    component: createAsyncComponent('../../pages/userRoomRank/index.vue'),
    meta: {
      title: '本房间用户榜单',
      keepAlive: false
    }
  },
  {
    path: '/saudiNationalDay',
    name: 'saudiNationalDay',
    component: createAsyncComponent('../../pages/saudiNationalDay/index.vue'),
    meta: {
      title: '沙特国庆',
      keepAlive: false
    }
  },
  {
    path: '/saudiArabianFlag',
    name: 'saudiArabianFlag',
    component: createAsyncComponent('../../pages/saudiArabianFlag/index.vue'),
    meta: {
      title: '沙特国旗',
      keepAlive: false
    }
  },
  {
    path: '/customizedGifts',
    name: 'customizedGifts',
    component: createAsyncComponent('../../pages/customizedGifts/index.vue'),
    meta: {
      title: '定制礼物',
      keepAlive: false
    }
  },
  {
    path: '/lastWeekCustomized',
    name: 'lastWeekCustomized',
    component: createAsyncComponent('../../pages/lastWeekCustomized/index.vue'),
    meta: {
      title: '(上周)定制礼物',
      keepAlive: false
    }
  },
  {
    path: '/monthCustomPage',
    name: 'monthCustomPage',
    component: createAsyncComponent('../../pages/monthCustomPage/index.vue'),
    meta: {
      title: '月定制展馆',
      keepAlive: false
    }
  },
  {
    path: '/historyRecord',
    name: 'historyRecord',
    component: createAsyncComponent('../../pages/historyRecord/index.vue'),
    meta: {
      title: '宝箱活动记录',
      keepAlive: false
    }
  },
  {
    path: '/historyRecordAr',
    name: 'historyRecordAr',
    component: createAsyncComponent('../../pages/historyRecordAr/index.vue'),
    meta: {
      title: '宝箱活动记录（阿语）',
      keepAlive: false
    }
  },
  {
    path: '/usersLivelyPage',
    name: 'usersLivelyPage',
    component: createAsyncComponent('../../pages/usersLivelyPage/index.vue'),
    meta: {
      title: '用户活跃榜',
      keepAlive: false
    }
  },
  {
    path: '/usersLivelyRules',
    name: 'usersLivelyRules',
    component: createAsyncComponent('../../pages/usersLivelyRules/index.vue'),
    meta: {
      title: '用户活跃榜(规则页)',
      keepAlive: false
    }
  },
  {
    path: '/usersLivelyLastMonth',
    name: 'usersLivelyLastMonth',
    component: createAsyncComponent('../../pages/usersLivelyLastMonth/index.vue'),
    meta: {
      title: '用户活跃榜(上月)',
      keepAlive: false
    }
  },
  {
    path: '/activeBanner',
    name: 'activeBanner',
    component: createAsyncComponent('../../pages/activeBanner/index.vue'),
    meta: {
      title: 'app规则页',
      keepAlive: false
    }
  },
  {
    path: '/UAENationalDay',
    name: 'UAENationalDay',
    component: createAsyncComponent('../../pages/UAENationalDay/index.vue'),
    meta: {
      title: '阿联酋国庆节活动',
      keepAlive: false
    }
  },
  {
    path: '/levelRulePage',
    name: 'levelRulePage',
    component: createAsyncComponent('../../pages/levelRulePage/index.vue'),
    meta: {
      title: '等级规则',
      keepAlive: false
    }
  },
  {
    path: '/newYearActivities',
    name: 'newYearActivities',
    component: createAsyncComponent('../../pages/newYearActivities/index.vue'),
    meta: {
      title: '新年活动',
      keepAlive: false
    }
  },
  {
    path: '/newYearRecord',
    name: 'newYearRecord',
    component: createAsyncComponent('../../pages/newYearRecord/index.vue'),
    meta: {
      title: '任务完成记录(新年活动)',
      keepAlive: false
    }
  },
  {
    path: '/newYearRulesReward',
    name: 'newYearRulesReward',
    component: createAsyncComponent('../../pages/newYearRulesReward/index.vue'),
    meta: {
      title: '规则和奖励(新年活动)',
      keepAlive: false
    }
  },
  {
    path: '/memoirPage',
    name: 'memoirPage',
    component: createAsyncComponent('../../pages/memoirPage/index.vue'),
    meta: {
      title: '回忆录',
      keepAlive: false
    }
  },
  {
    path: '/ramadanActivity',
    name: 'ramadanActivity',
    component: createAsyncComponent('../../pages/ramadanActivity/index.vue'),
    meta: {
      title: '斋月活动',
      keepAlive: false
    }
  },
  {
    path: '/ramadanRecord',
    name: 'ramadanRecord',
    component: createAsyncComponent('../../pages/ramadanRecord/index.vue'),
    meta: {
      title: '斋月活动(记录页)',
      keepAlive: false
    }
  },
  {
    path: '/ramadanRules',
    name: 'ramadanRules',
    component: createAsyncComponent('../../pages/ramadanRules/index.vue'),
    meta: {
      title: '斋月活动(规则页)',
      keepAlive: false
    }
  },
  {
    path: '/ramadanReward',
    name: 'ramadanReward',
    component: createAsyncComponent('../../pages/ramadanReward/index.vue'),
    meta: {
      title: '斋月活动(奖励页)',
      keepAlive: false
    }
  }
]
